module.exports = __webpack_public_path__ + "img/header_background.04f1150b.jpg";